import { Button } from "@/components/common/Button";
import Modal from "@/components/common/Modal";
import { useUserStore } from "@/modules/auth/store/user";
import { useTranslation } from "react-i18next";

type Props = {
  onYes: (net: "ton" | "base") => void;
  onNo: () => void;
  onClose: () => void;
};

const RefcodeVerify = ({ onYes, onNo, onClose }: Props) => {
  const { t } = useTranslation();

  const { invitedBy } = useUserStore();

  return (
    <Modal title={""} onClose={onClose}>
      <div className="w-full flex flex-col items-center p-8 gap-6">
        <div className="flex flex-col items-center gap-1 text-center">
          <p className="text-[1.0625rem] leading-[1.375rem] text-hint -tracking-[0.025rem]">
            {t("main-page.modal.confirm", {
              refcode: invitedBy,
            })}
          </p>
        </div>

        <div className="w-full flex items-center gap-4">
          <Button
            onClick={onNo}
            text={t("main-page.modal.no")}
            size="large"
            mode="bezeled"
            className="w-full"
          />

          <Button
            onClick={() => {
              onYes("ton");
            }}
            text={t("main-page.modal.yes")}
            size="large"
            className="w-full"
          />
        </div>
      </div>
    </Modal>
  );
};

export default RefcodeVerify;
